import { RouterView } from 'vue-router'

let app = { layout: 'default', middleware: 'auth' }
let admin = { middleware: 'auth' }

export default [
    {
        name: 'subscriptions',
        path: '/subscriptions',
        component: () => import('~/pages/zapo/subscription/subscriptions.vue'),
        meta: app,
    },

    {
        name: 'sales-leads',
        path: '/sales/leads',
        component: () => import('~/pages/zapo/sales/leads.vue'),
        meta: app,
    },

    {
        name: 'sales-prospects',
        path: '/sales/prospects/:view',
        component: () => import('~/pages/zapo/sales/prospects.vue'),
        meta: app,
        props: true
    },




    // {
    //     name: 'prospects',
    //     path: '/prospects',
    //     component: () => import('~/pages/zapo/prospects.vue'),
    //     meta: app,
    // },

    {
        name: 'onboarding',
        path: '/onboarding',
        component: () => import('~/pages/zapo/onboarding.vue'),
        meta: app,
    },

    {
        name: 'company',
        path: '/company/:id',
        component: () => import('~/pages/zapo/company/index.vue'),
        meta: admin,
        props: true,
        children: [
            { path: 'company', component: () => import('~/pages/zapo/company/company.vue') },
            { path: 'ads', component: () => import('~/pages/zapo/company/ads.vue') },
            { path: 'sign-up', component: () => import('~/pages/zapo/company/sign-up.vue') },
            { path: 'onboarding', component: () => import('~/pages/zapo/company/onboarding.vue') },
            { path: 'about', component: () => import('~/pages/zapo/company/about.vue') },
            { path: 'landing-page', component: () => import('~/pages/zapo/company/landing-page.vue') },
            { path: 'assets', component: () => import('~/pages/zapo/company/assets.vue') },
            { path: 'invoices', component: () => import('~/pages/zapo/company/invoices.vue') },
            { path: 'cards', component: () => import('~/pages/zapo/company/cards.vue') },
            { path: 'performance', component: () => import('~/pages/zapo/company/performance.vue') },
            { path: 'verification', component: () => import('~/pages/zapo/company/veriff.vue') },
        ]
    },

    {
        name: 'layout',
        path: '/layout',
        component: () => import('~/pages/zapo/test.vue'),
        meta: app,
    },

    {
        path: '/subscription/:id/search-terms',
        component: () => import('~/pages/zapo/subscription/search-terms.vue'),
        meta: app,
        props: true,
    },

    {
        name: 'lp',
        path: '/landing-page/:id',
        component: () => import('~/pages/zapo/landing-page.vue'),
        meta: app,
        props: true,
    },




    {
        name: 'calendar',
        path: '/calendar',
        component: () => import('~/pages/customer/calendar.vue'),
        meta: app,
    },

    {
        name: 'tasks',
        path: '/tasks',
        component: () => import('~/pages/customer/tasks.vue'),
        meta: app,
    },

    {
        name: 'events',
        path: '/events',
        component: () => import('~/pages/customer/events.vue'),
        meta: app,
    },




    {
        name: 'management-users',
        path: '/management/users',
        component: () => import('~/pages/zapo/management/user/users.vue'),
        meta: { ...app },
    },

    {
        name: 'management-user',
        path: '/management/user/:id',
        component: () => import('~/pages/zapo/management/user/user.vue'),
        meta: { ...app },
        props: true
    },

    {
        path: '/tools/',
        component: RouterView,
        meta: { ...app },
        children: [
            { path: 'locations', component: () => import('~/pages/zapo/tools/locations.vue') },
            { path: 'users', component: () => import('~/pages/zapo/tools/users.vue') },
            { path: 'user/:id', component: () => import('~/pages/zapo/tools/user.vue'), props: true },
            { path: 'search-terms', component: () => import('~/pages/zapo/tools/search-terms.vue') },
            { path: 'domains', component: () => import('~/pages/zapo/tools/domains.vue') },
            { path: 'system-options', component: () => import('~/pages/zapo/tools/system-options.vue') },
            { path: 'sms-templates', component: () => import('~/pages/zapo/tools/sms-templates.vue') },
            { path: 'lead-quality-management', component: () => import('~/pages/zapo/tools/lead-quality.vue') },
        ]
    },


    {
        path: '/reports/',
        component: RouterView,
        meta: { ...app },
        children: [
            { path: 'lead-feed', component: () => import('~/pages/zapo/reports/lead-feed.vue') },
            { path: 'lead-volume', component: () => import('~/pages/zapo/reports/lead-volume.vue') },
            { path: 'cancellations', component: () => import('~/pages/zapo/reports/cancellations.vue') },
            { path: 'commission', component: () => import('~/pages/zapo/reports/commission.vue') },
            { path: 'calls', component: () => import('~/pages/zapo/reports/calls.vue') },
            { path: 'unknown-calls', component: () => import('~/pages/zapo/reports/unknown-calls.vue') },
            { path: 'sales-metrics', component: () => import('~/pages/zapo/reports/sales-metrics.vue') },
            { path: 'mrr', component: () => import('~/pages/zapo/reports/mrr.vue') },
            { path: 'salesboard', component: () => import('~/pages/zapo/reports/salesboard.vue'), meta: { layout: false } },
        ]
    },

    {
		name: 'notifications',
		path: '/notifications',
		component: () => import('~/pages/customer/notifications.vue'),
		meta: { ...app },
	},
]
